import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field, FieldArray, formValueSelector} from 'redux-form';
import FilterableSelect from "../inputs/FilterableSelect";

const AddProcedureForm = ({handleSubmit, procedures, onProcedureAdded, onSaveProcedureAdded}) => {
  return (
    <form className="dashboard-form" onSubmit={handleSubmit}>
      { 
        (!onSaveProcedureAdded && onProcedureAdded) &&
          <span className="dashboard-form-item">
            <label
              className="profile-item__label"
              htmlFor="">
              Create Invoice?
            </label>
            <Field
              component="select"
              name="create_invoice"
              className="dashboard-form__input dashboard-form__select"
              normalize={value => value === 'true'}>
              <option>Please select</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </Field>
          </span>
      }

      <span className="dashboard-form-item" style={{margin:"2rem 0"}}>
        <FieldArray name="procedures" component={renderProcedureFields} props={{procedures}}/>
      </span>

      <div style={{display:"flex",flexDirection:"flex-start"}}>
        <button className="dashboard__primary-btn dashboard-form__btn">Save Procedure</button>
      </div>
    </form>
  )
};

let ProcedureEntryField = ({procedures, procedure, index, onRemove, selectedProcedure}) => (
  <li>
    <div style={{display:"flex", alignItems:"center", margin:"2rem 0"}}>
      <span className="dashboard-form-item" style={{width:"auto"}}>
        <label className="profile-item__label" htmlFor="">
        Procedure #{index+1}
        </label>
        <Field
          name={`${procedure}.procedure`}
          className="filterable-select search-section embedded"
          component={FilterableSelect}
          props={
            {
              items: procedures,
              placeholder:"Enter procedure name...",
              filterBy:["name"]
            }
          }/>
      </span>
      {
        selectedProcedure &&
          <React.Fragment>
            <span className="dashboard-form-item" style={{width:"auto"}}>
              <label className="profile-item__label" htmlFor="">
                Summary
              </label>
              <Field
                component="input"
                style={{width:"auto"}}
                name={`${procedure}.summary`}
                className="dashboard-form__input"
                type="text"
                placeholder="Summary"/>
            </span>
            <span className="dashboard-form-item" style={{width:"auto"}}>
              <label className="profile-item__label" htmlFor="">
                Unit Price
              </label>
              <div
                style={{width:"auto"}}
                className="dashboard-form__input">
                {selectedProcedure.price || "0.00"}
              </div>
            </span>
            <span className="dashboard-form-item" style={{marginLeft: "1rem", width:"auto"}}>
              <label className="profile-item__label" htmlFor=""> Delete </label>
              <button className="dashboard__secondary-btn" onClick={onRemove}>
                <label className="profile-item__label" htmlFor="">
                  <i className="fas fa-trash"/>
                </label>
              </button>
            </span>
          </React.Fragment>
      }
    </div>
  </li>
);

const selector = formValueSelector('addProcedureForm');

ProcedureEntryField = connect(
  (state, props) => ({
    selectedProcedure:  selector(state, `${props.procedure}.procedure`)
  })
)(ProcedureEntryField);

const renderProcedureFields = ({fields, procedures}) => (
  <ul>
    {fields.map((procedure, index) => (
      <ProcedureEntryField
        key={index}
        index={index}
        procedure={procedure}
        procedures={procedures}
        onRemove={() => fields.remove(index)}/>
    ))}
    <li>
      <button
        className="dashboard__secondary-btn"
        type="button"
        onClick={() => fields.push({quantity:1})}>
        {`${fields.length > 0 ? "Add Another Procedure" : "Click to add a Procedure"} `}
      </button>
    </li>
  </ul>
);

export default reduxForm({
  form: "addProcedureForm"
})(AddProcedureForm);
